import type { UrlParams } from 'utils/url/url.interface'

import FcidStore from './FcidStore'

const initializeFcid = (urlParams: UrlParams) => new FcidStore(urlParams)

export type { default as FcidStore } from './FcidStore'
export default initializeFcid
